import { OnInit, Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { IDtoRequisition } from 'app/shared/models/opening/dto-requisition.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { RecruitmentService } from 'app/views/appviews/recruitment/recruitment.service';
import { OpeningService } from '../../opening.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConfig } from 'app/app.config';
import { SnotifyService } from 'ng-snotify';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { ValidatorService } from 'app/shared/services/validator.service';
import { SecurityService } from 'app/shared/services/security.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { WorkingDayService } from 'app/views/appviews/quote/working-day.service';
import { DatePipe } from '@angular/common';
@Component({
    selector: '[requisition-edit]',
    templateUrl: './requisition-edit.template.html',
    styleUrls: ['./requisition-edit.style.scss']
})
export class RequisitionEditComponent implements OnInit, OnChanges {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;
    /**Formularios */
    private formGeneralData: FormGroup;
    /**Notificaciones */
    private configToast: any;
    /**Catalogos */
    private catalogContractTypes: Observable<ISelect[]>;
    private catalogPayrollOfficers: Observable<ISelect[]>;
    private catalogSupervisors: Observable<ISelect[]>;
    private catalogWorkingDays: Observable<IDtoCatalog[]>;
    private catalogStoreRoutes: ISelect[];
    /**Inputs */
    @Input() private requisition: IDtoRequisition;
    private action: string;
    @Output() getRequisitionId = new EventEmitter<number>();
    @Output() routeName = new EventEmitter<string>();
    private locale: string = 'es';
    /**Securty */
    private showRoles: any;
    public constructor(private formBuilder: FormBuilder
        , public snotifyService: SnotifyService
        , private configGeneral: AppConfig
        , private spinner: NgxSpinnerService
        , private openingService: OpeningService
        , private recruitmentService: RecruitmentService
        , private configurationService: ConfigurationService
        , private securityService: SecurityService
        , private identityService: IdentityService
        , private workingDayService: WorkingDayService
        , public datepipe: DatePipe) {
        this.showRoles = this.securityService.getUserRolesStorage();
        this.initializeFormGerneralData();
        this.configToast = configGeneral.getConfigToast();
    }
    ngOnInit(): void {
        if (this.configurationService.isReady) {
            this.getCatalog();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalog();
            });
        }
        this.action = this.requisition.requisitionId > 0 ? 'new' : 'update';
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.requisition.currentValue.positionId !== undefined && changes.requisition.currentValue.positionId !== null) {
            if (this.requisition.positionId > 0) {
                this.patchValueGeneralData();
                this.catalogWorkingDays = this.workingDayService.getCatalogWorkingDays(this.requisition.companyId);
            }
        }
    }
    private getCatalog() {
        this.catalogContractTypes = this.openingService.getCatalogContractTypes();
        this.catalogPayrollOfficers = this.openingService.getCatalogPayrollOfficers();
        this.catalogSupervisors = this.openingService.getCatalogSupervisors();
        this.openingService.getCatalogStoreRoutes().subscribe(x => {
            this.catalogStoreRoutes = x;
        });
    }
    private initializeFormGerneralData() {
        this.formGeneralData = this.formBuilder.group({
            route: [null, [Validators.required]],
            operationObservation: [null, [Validators.required, Validators.maxLength(500)]],
            clientInterview: [null, [Validators.required]],
            payrollOfficerId: [null, [Validators.required]],
            requisitionTypeContractId: [null, [Validators.required]],
            supervisorId: [null, [Validators.required]],
            workingDayId: [null, [Validators.required]],
            endContractDate: [null]
        });
    }
    private submitForm(form: FormGroup) {
        if (form.valid) {
            const value = form.value;
            this.requisition.operationObservation = value.operationObservation;
            this.requisition.clientInterview = value.clientInterview;
            this.requisition.payrollOfficerId = value.payrollOfficerId;
            this.requisition.supervisorId = value.supervisorId;
            this.requisition.workingDayId = value.workingDayId;
            this.requisition.requisitionTypeContractId = value.requisitionTypeContractId;
            this.requisition.statusRequestId = 2;
            if (value.requisitionTypeContractId == 1){
            this.requisition.endContractDate =  new Date(this.datepipe.transform(value.endContractDate, 'yyyy-MM-dd'));
            }
            else{
                this.requisition.endContractDate = null;
            }
            this.requisition.route = value.route.toString();
            this.requisition.routeNames = this.catalogStoreRoutes.filter(x => value.route.includes(x.id)).map(a => a.text).toString();

            if (this.requisition.requisitionId > 0) {
                this.updateRequisition();
            } else {
                this.addRequisition();
            }
        } else {
            this.snotifyService.error('Llene todos los datos para poder continuar'
                , 'Error', this.configToast);
            this.configGeneral.touchedControls(form);
        }
    }
    private addRequisition(): void {
        this.requisition.coordinatorId = this.showRoles.employeeId;
        this.openingService.addRequisition(this.requisition).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registro guardados correctamente'
                        , 'Éxito', this.configToast);
                    this.requisition = x.data as IDtoRequisition
                    this.getRequisitionId.emit(+this.requisition.requisitionId)
                    this.addModuleLogRequistion();
                    this.addModuleLogPosition();
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private updateRequisition(): void {
        this.requisition.coordinatorId = this.showRoles.employeeId;
        this.openingService.updateRequisition(this.requisition).subscribe(
            (x) => {
                if (x.isCorrect) {
                    this.snotifyService.success('Registros actualizados correctamente'
                        , 'Éxito', this.configToast);
                    this.requisition = x.data as IDtoRequisition
                    this.addModuleLogRequistion();
                    this.addModuleLogPosition();
                } else {
                    this.snotifyService.error(x.message
                        , 'Error', this.configToast);
                }
            },
            (errMessage) => {
                this.spinner.hide();
                this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
            });
    }
    private patchValueGeneralData(): void {
      if (this.requisition.endContractDate === null) {
        let transformedDate = new Date();
        let timezoneOffset = transformedDate.getTimezoneOffset();
        transformedDate.setMinutes(transformedDate.getMinutes() + timezoneOffset);
        this.requisition.endContractDate = transformedDate;
    }
    else {
      let transformedDate = new Date(this.datepipe.transform(this.requisition.endContractDate, 'yyyy-MM-dd'));
      let timezoneOffset = transformedDate.getTimezoneOffset();
      transformedDate.setMinutes(transformedDate.getMinutes() + timezoneOffset);
      this.requisition.endContractDate = transformedDate;
    }
        this.formGeneralData.patchValue(this.requisition);
        if (this.requisition.route != null) {
            this.formGeneralData.get('route').setValue(this.requisition.route.split(','));
        }
    }
    private addModuleLogRequistion(): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Requisitions';
        dto.module = 'requisitionReviews';
        dto.action =  this.action;
        dto.registryAffectedId = this.requisition.id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    private addModuleLogPosition(): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Positions';
        dto.module = 'requisitionReviews';
        dto.action = 'release';
        dto.registryAffectedId = this.requisition.positionId;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
    contractDate() {
      let id = this.formGeneralData.get('requisitionTypeContractId').value;
    if (id == 1) {
      this.formGeneralData.get('endContractDate').setValidators([Validators.required]);
    } else {
      this.formGeneralData.get('endContractDate').clearValidators();
    }
    this.formGeneralData.get('endContractDate').updateValueAndValidity();
    }
}

